import SplitNavLinks from './split-nav-links';

export default SplitNavLinks;
